import { faqPage } from '@sly/frontend/common/helpers/html_headers';
import Accordion from '@sly/frontend/react/shared/components/Accordion';
import cx from 'classnames';
import Helmet from 'next/head';
import React from 'react';
import { Faqs } from 'sly/hubPage/components/HubPage/HubPage.types';

import MarketingPageTitle from '../MarketingPageTitle';
import MarketingPageWrapper from '../../MarketingPageWrapper';

export interface FaqBoxProps {
  faqs: Faqs[];
}

export default function FaqBox({ faqs }: FaqBoxProps) {
  const faqItems = faqs?.[0]?.FaqItem?.map(({ id, title, description }) => ({
    question: title,
    answer: description,
    open: false,
    id,
  }));

  return (
    <MarketingPageWrapper>
      <Helmet> {faqs?.length && faqPage(faqs)}</Helmet>
      <MarketingPageTitle title={faqs?.[0]?.head} font='title-large' />
      {faqItems?.length && (
        <div
          className='flex w-full flex-col lg:w-[42.5rem]'
          data-tp-id='gen-Flex-fabeb88c-f454-4d18-9570-645b67c1a63c'
        >
          {faqItems?.map((item, index) => (
            <div
              className={cx(faqItems?.length - 1 !== index && 'mb-xl')}
              key={item.id}
              data-tp-id='gen-Block-3006cbed-9564-44a8-b87a-cf3ca445806e'
            >
              <Accordion title={item.question} content={item.answer} parseRaw />
              <hr data-tp-id='gen-Hr-3048d1f0-59af-4b78-b528-b94592c99c29' />
            </div>
          ))}
        </div>
      )}
    </MarketingPageWrapper>
  );
}
